export default "__VITE_ASSET__IKDOsHn5__"